import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({
  name: 'simplePipeMsk',
})
export class SimplePipeMskPipe implements PipeTransform {
  constructor() {
    moment.locale('ru');
  }
  transform(value: string): string {
    if (!value) {
      return '';
    }

    // Преобразование даты в формат МСК
    const mskDate = moment.utc(value).tz('Europe/Moscow').format('DD.MM.YYYY HH:mm:ss');

    // Добавление "(МСК)" в конец строки
    return `${mskDate} (МСК)`;
  }
}
